<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-danger ">
					<div class="card-header">
						Master Delivery Item Categories
					</div>
					<div class="card-body overflow-auto">
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th scope="col" style="width:20%">Company</th>
									<th scope="col" style="width:20%">Category</th>
									<th scope="col" style="width:40%">Description</th>
									<th scope="col" style="width:10%">Validity</th>
                  <th scope="col" style="width:10%">Manage</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="i in master_delivery_item_categories">
									<td>{{i.company}}</td>
									<td>{{i.category}}</td>
                  <td>{{i.description}}</td>
                  <td>{{i.validity}}</td>
                  <td>
												<button class="btn btn-success fa fa-play" v-if="i.validity == 'Inactive'" @click="changeStatus(i.id)"></button>
												<button class="btn btn-danger fa fa-square" v-else-if="i.validity == 'Active'" @click="changeStatus(i.id)"></button>
									</td>
								</tr>
							</tbody>	
						</table>
            <br>
            <div class="col-md-12">
									<div class="row">
										<div class="col-md-4">
											<div class="form-group">
												<select v-model="company_code" style="width: 100% !important" class="form-control">
                            <option v-for="j in companies" :key="j.code" :value="j.code">
                              {{ j.code }}
                             </option>
                             <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                          </select>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<input class="form-control" v-model="category" label="routes"  placeholder="Enter Delivery Item Category Name">
											</div>
										</div>
                    <div class="col-md-4">
											<div class="form-group">
												<input class="form-control" v-model="description" label="description"  placeholder="Enter Delivery Item Category Description">
											</div>
										</div>
                    <div class="col-md-4">
											<div class="form-group">
												<button class="btn btn-primary" @click="addMasterDeliveryItemCategory">Add</button>
											</div>
										</div>
									</div>
								</div>
					</div>
					<div class="card-footer">
						<pagination :pagination="pagination"
						 	@prev="getMasterDeliveryItemCategories(pagination.prevPageUrl)"
						  @next="getMasterDeliveryItemCategories(pagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: {pagination:Pagination},
        
        created(){
			this.getCompanies();
        	this.getBranches();
        	this.getMasterDeliveryItemCategories();
        },
        
        data(){
        	return {
        		branches: [],
				companies: [],
        		master_delivery_item_categories: [],
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		branch_code: '',
				company: '',
				company_code: '',
				category: '',
         		route: '',
            description: '',
        	}
        },
        
        methods: {
			getCompanies(){
        		axios.post("/api/getCompanies")
        		.then(response => {
        			this.companies = response.data;
        		})
        	},

        	getBranches(){
        		axios.post("/api/getSAPBranches")
        		.then(response => {
        			this.branches = response.data;
        		})
        	},
        	
        	getMasterDeliveryItemCategories(url="/api/getMasterDeliveryItemCategories"){
        		axios.post(url)
        		.then(response => {
        			this.master_delivery_item_categories = response.data.data.data;
        			this.configPagination(response.data.data);
        		});
        	},
        	
        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},
    			
    			addMasterDeliveryItemCategory(){
    				axios.post("/api/addMasterDeliveryItemCategory", {company_code: this.company_code, category: this.category, description:this.description})
    				.then(() => {
    					this.getMasterDeliveryItemCategories();
    					toast.fire({
    						title: 'Added',
    						icon: 'success'
    					});
    				})
    				.catch(() => {
    					toast.fire({
    						title: 'Failed! Input Valid Date',
    						icon: 'error'
    					});
    				});
    			},
    			
    			changeStatus(id){
    				axios.post("/api/updateMasterDeliveryItemCategory", {id: id})
    				.then(() => {
    					this.getMasterDeliveryItemCategories();
    				})
    				.catch(() => {
    					toast.fire({
    						title: 'Failed!',
    						icon: 'error'
    					});
    				});
    			},
    			
    			deleteRoute(id){
    				axios.post("/api/deleteMasterDeliveryItemCategory", {id: id})
    				.then(() => {
    					this.getLinkages();
    				})
    				.catch(() => {
    					toast.fire({
    						title: 'Failed!',
    						icon: 'error'
    					});
    				});
    			},
        }
    }
</script>
